import { render, staticRenderFns } from "./viewPastSubscription.vue?vue&type=template&id=0ba70d48&"
import script from "./viewPastSubscription.vue?vue&type=script&lang=js&"
export * from "./viewPastSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports